import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Config} from '../../../services/utils/Config';
import {HomeService, IHomeHistory,} from '../../../services/home.service';
import {getMonthAndDay, getTimeFromTimestamp, goBack, Utility, formatGMTTime} from '../../../services/utils/utility';
import {HomeHistoryFilterModalComponent} from '../home-history-filter-modal/home-history-filter-modal.component';
import {LanguageChangeService} from '../../../services/language-change.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Constants} from 'src/app/services/utils/Constants';
import {GDOService} from "../../../services/gdo.service";
import {ListHistory} from "../../models/hav-models";
import {Config as gdoConfig} from "../../../services/utils/gdo-config";

@Component({
  selector: 'app-home-history',
  templateUrl: './home-history.component.html',
  styleUrls: ['./home-history.component.css'],
})
export class HomeHistoryComponent implements OnInit {
  pageSize = gdoConfig.HISTORY_ON_ONE_PAGE;
  defaultPageNo = gdoConfig.DEFAULT_PAGE_NO;
  pageNo = this.defaultPageNo;
  goBack = goBack;
  errorMessage;
  private homeId;

  eventHistory: Array<IHomeHistory> = [];
  issueHistory: Array<IHomeHistory> = [];
  activities = Config.HISTORY_CHECKLISTS;
  gdoActivities = gdoConfig.HISTORY_CHECKLISTS;
  sources = Config.SOURCES_CHECKLISTS;
  disableCall = false;
  fromDate;
  toDate;
  filters: any = { setFilter: false };
  recordMsg = '';
  showError = false;
  currentScrollPosition: number = 0;
  modalRef: BsModalRef;
  //Selected Default Language
  langCode: string;
  defaultLangCode: string;

  filterData: any = {pageSize: this.pageSize, sortOrder: "desc", orderBy: "ID"};

  gdoEvent: ListHistory[] = [];

  gdoRecordIds: any[] = [];

  homeHistory = [];

  UNKNOWN_SOURCE = 'Unknown Source';
  STATUS_UPDATE = Config.STATUS_UPDATE[this.langService.getCurrentLanguage()];
  localOffsetInSeconds = new Date().getTimezoneOffset() * 60;
  FORMATTED_EVENT_TYPES = new Set(["Alexa", "Google Home", "Firmware Update"])
  private static readonly FIRMWARE_EVENTS = new Set(["Completed Successfully", "Unsuccessful"]);

  constructor(
    public translate: TranslateService,
    private homeService: HomeService,
    private activatedRoute: ActivatedRoute,
    private langService: LanguageChangeService,
    private modalService: BsModalService,
    private gdoService: GDOService
  ) { }

  getDateOnInit() {
    const now = new Date()

    const fromDate = new Date(now)
    fromDate.setMonth(now.getMonth() - 2)

    const toDate = new Date(now)
    toDate.setMonth(now.getMonth() + 2)

    this.fromDate = fromDate.getTime()
    this.toDate = toDate.getTime()

  }

  ngOnInit() {
    this.langCode = this.langService.getCurrentLanguage();
    this.defaultLangCode = this.langService.getDefaultLanguage();

    this.getDateOnInit();
    this.activatedRoute.params.subscribe(
      (params) => (this.homeId = params['homeID'])
    );
    this.filterData.toDate = this.toDate/1000;
    this.filterData.fromDate = this.fromDate/1000;
    this.applyFilter(this.homeId, this.filterData);
  }

  getImageSrc(event) {
    if (event === '') {
      return '../../../../assets/images/history/svg/Connection Error.svg';
    }
    if (HomeHistoryComponent.FIRMWARE_EVENTS.has(event)) {
      return '../../../../assets/images/history/svg/Firmware Update.svg';
    }
    return (
      '../../../../assets/images/history/svg/' +
      event.replace(/\//g, '-') +
      '.svg'
    );
  }

  getPageTitle() {
    let title: string = this.translate.instant('HOME.HISTORY.TITLE');
    if (title) {
      title = title.replace('{home} -', '');
      return title;
    }
  }

  getTitle() {
    return `  ${this.homeService.getHomeById(this.homeId).homeName}`;
  }


  onScroll(event) {
    if (this.currentScrollPosition + 250 < event.currentScrollPosition) {
      if (!this.disableCall) {
        this.disableCall = true;
        this.applyFilter(this.homeId, this.filterData);
      }
      this.currentScrollPosition = event.currentScrollPosition;
    }
  }

  opeFiltersModal() {
    const initialState = {
      homeID: this.homeId,
      activities: this.activities,
      gdoActivities: this.gdoActivities,
      sources: this.sources,
      filters: this.filters,
    }

    this.modalRef = this.modalService.show(HomeHistoryFilterModalComponent, {
      initialState: initialState,
      class: 'home-history-filter',
      ...Constants.MODAL_CONFIG
    });
    this.modalRef.content.closeBtnName = 'Close';
    this.modalRef.content.event.subscribe(filterData => {
      if (filterData) {
        if (filterData) {
          console.log('filtered Data', filterData);
          this.pageNo = this.defaultPageNo;
          this.homeHistory = [];
          this.gdoEvent = [];
          this.eventHistory = [];
          this.issueHistory = [];
          this.filters = filterData;
          this.filters.timestamp = Date.now();
          this.filterData.setFilter = filterData.setFilter;
          this.setFilter(filterData);
          this.filterHomeEvent(this.homeId, this.filterData);
          this.currentScrollPosition = 0;
        }
      }
    });
    this.modalRef.content.eventClose.subscribe(filterData => {
      if (filterData) {
        if (filterData) {
          console.log('cross modal', filterData);
          this.pageNo = this.defaultPageNo;
          this.filters = filterData;
          this.filters.timestamp = Date.now();
        }
      }
    });
  }

  private filterHomeEvent(homeId: string, body: any) {
    this.gdoService.filterHomeEvent(homeId, body).subscribe({
      next: (res: any) => {
        const event = res.data || [];
        const issues = res.issues || [];
        const gdoEvent = res.gdoEvents || [];

        if (event.length > 0 || gdoEvent.length > 0 || issues.length > 0) {
          this.setEvent(event);
          if (event.length > 0) {
            this.pageNo++;
            this.filterData.pageNumber = this.pageNo;
          }

          this.setIssue(issues);

          const eventGroupSet = new Set<number>([1, 3, 4, 5, 6 ,7 , 8 ,9 , 10]);
          for (const event of gdoEvent) {
            if (!eventGroupSet.has(event.eventGroupId) || (event.operationEvent === 0 && event.eventGroupId == 2)) {
              continue; // Skip events that are not in the specified groups
            }

            this.gdoService.mappingEvent(event, this.langCode, true);
            event.day = this.getMonthAndDay(event.timeStamp);
            event.showTime = getTimeFromTimestamp(event.timeStamp);
            this.gdoRecordIds[event.deviceId] = {
              key: event.deviceId,
              value: event.recordId,
            };
            this.gdoEvent.push(event);
          }

          if (gdoEvent.length > 0) {
            this.filterData.havRecordId = Object.entries(this.gdoRecordIds)
              .map(([key, value]) => `${key}:${value.value === 0 ? -1 : value.value}`)
              .join(',');
          }

          this.disableCall = false;
          this.homeHistory = [...this.eventHistory, ...this.gdoEvent];
          this.homeHistory.sort((a, b) => b.timeStamp - a.timeStamp);
        } else {
          this.disableCall = true;
          if (this.homeHistory.length === 0) {
            this.showError = true;
            const translationKey = this.filters.setFilter ? 'HOME.HISTORY.NO_RECORDS_FILTER' : 'HOME.HISTORY.NO_RECORDS';
            this.translate.get(translationKey).subscribe((value) => (this.recordMsg = value));
          }
        }
      },
      error: (err: any) => {
        console.error('Error fetching gets:', err);
      },
    });
  }

  private setIssue(issues: any[]) {
    issues.forEach((element) => {
      let languageMappingObj = Config.HISTORY_CHECKLISTS.find(
        (ele) =>
          ele[this.langService.getDefaultLanguage()] === element.event
      );
      let languageMappingSourceList = Config.SOURCES_CHECKLISTS.find(
        (ele) =>
          ele[this.langService.getDefaultLanguage()] ===
          element.eventType
      );
      const eventTypeLocale = languageMappingSourceList
        ? languageMappingSourceList[
          this.langService.getCurrentLanguage()
          ]
        : element.eventType;
      const history: IHomeHistory = {
        eventLocaleName: languageMappingObj
          ? languageMappingObj[this.langService.getCurrentLanguage()]
          : element.event,
        event: element['event'] ? element['event'] : '',
        eventTypeLocale: eventTypeLocale,
        eventDescription: element['eventType']
          ? element['eventType'] === this.UNKNOWN_SOURCE
            ? this.STATUS_UPDATE
            : eventTypeLocale
          : '',
        user: element['user']
          ? element['user']
          : element['eventType']
            ? element['eventType'] === this.UNKNOWN_SOURCE
              ? this.STATUS_UPDATE
              : eventTypeLocale
            : '',
        lockName: element['deviceName'] ? element['deviceName'] : '',
        time: new Date(
          (element['timestamp'] + this.localOffsetInSeconds) * 1000
        ),
        lockOffsetInMinutes: this.homeService.getLockOffsetInMinutes(
          element['timezone']
        ),
        eventType: element['eventType']
          ? element['eventType'] === this.UNKNOWN_SOURCE
            ? this.STATUS_UPDATE
            : eventTypeLocale
          : '',
        day : this.getMonthAndDay(element['timestamp']),
        showTime : formatGMTTime(this.convertUTCToGMT(element['timestamp'], element['timezone']))
      };
      const exist = this.issueHistory.find( event => event.timeStamp === history.timeStamp && event.eventType === history.eventType);
      if (!exist) {
        this.issueHistory.push(history);
      }
    });
  }


  getMonthAndDay(timestamp: number): string {
    const currentDate = new Date();
    const date = new Date(timestamp * 1000);
    const day = date.toLocaleString('en-US', { day: '2-digit' });
    const currentDay = currentDate.toLocaleString('en-US', { day: '2-digit' });
    if (day === currentDay) {
      return 'Today';
    }
    const month = date.toLocaleString('en-US', { month: 'long' });

    return `${month}, ${day}`;
  }

  private setEvent(events: any[]) {
    events.forEach((element) => {
      let languageMappingObj = Config.HISTORY_CHECKLISTS.find((ele) => ele[this.langService.getDefaultLanguage()] === element.event);
      let languageMappingSourceList = Config.SOURCES_CHECKLISTS.find((ele) => ele[this.langService.getDefaultLanguage()] === element.eventType);
      const eventTypeLocale = languageMappingSourceList
        ? languageMappingSourceList[
          this.langService.getCurrentLanguage()
          ]
        : element.eventType;
      const history: IHomeHistory = {
        eventLocaleName: languageMappingObj
          ? languageMappingObj[this.langService.getCurrentLanguage()]
          : element.event,
        event: element['event'] ? element['event'] : '',
        eventTypeLocale: eventTypeLocale,
        eventDescription: element['eventType']
          ? element['eventType'] === this.UNKNOWN_SOURCE
            ? this.STATUS_UPDATE
            : eventTypeLocale
          : '',
        user: element['user']
          ? element['user']
          : element['eventType']
            ? element['eventType'] === this.UNKNOWN_SOURCE
              ? this.STATUS_UPDATE
              : eventTypeLocale
            : '',
        lockName: element['deviceName'] ? element['deviceName'] : '',
        time: new Date(
          (element['timestamp'] + this.localOffsetInSeconds) * 1000
        ),
        lockOffsetInMinutes: this.homeService.getLockOffsetInMinutes(
          element['timezone']
        ),
        eventType: element['eventType']
          ? element['eventType'] === this.UNKNOWN_SOURCE
            ? this.STATUS_UPDATE
            : eventTypeLocale
          : '',
        timeStamp: element['timestamp'],
        day : this.getMonthAndDay(element['timestamp']),
        showTime : formatGMTTime(this.convertUTCToGMT(element['timestamp'], element['timezone']))
      };
      console.log(`User: ${element['user']}, TimeStamp: ${history.timeStamp}`);
      this.mappingLockEvent(history);
      const existEvent = this.eventHistory.find( event => event.timeStamp === history.timeStamp && event.eventType === history.eventType);
      if (!existEvent) {
        this.eventHistory.push(history);
      }
    });
  }


  private mappingLockEvent(event: IHomeHistory) {
    event.eventDes = event.user
    event.eventName = `${event.lockName}: ${event.eventLocaleName}`
    if (event.event != 'Locked' && event.event != 'Auto Locked' && event.event != 'Door Open') {
      event.eventColor = 'list-row-data';
      event.eventIcon = this.getImageSrc(event.event);

      if (event.user != event.eventType && (event.event === 'Unlocked' || event.event === 'Jammed')) {
        event.eventDes = `${event?.eventType} / ${event.user}`;
      }

    } else if ((event.event === 'Locked' || event.event === 'Auto Locked')) {
      event.eventColor = 'list-row-data list-row-data-locked';
      event.eventIcon = this.getImageSrc(event.event);
      if (event.user != event.eventType) {
        event.eventDes = `${event?.eventType} / ${event.user}`;
      }
    } else if (event.event === 'Door Open') {
      event.eventColor = 'list-row-data';
      event.eventIcon = this.getImageSrc(event.event);
      if (event.user != event.eventType) {
        event.eventDes = `${event?.eventType} / ${event.user}`;
      }
    }
    if (this.FORMATTED_EVENT_TYPES.has(event.eventType)) {
      event.eventName = `${event.eventType}: ${event.eventLocaleName}`
      event.eventDes = `${event.user}`;
    }
  }

  applyFilter(homeId: string, filterData: any) {
    this.showError = false;
    this.filterHomeEvent(homeId, this.filterData);
  }

  setFilter(filters: any) {

    let filterLockActivity: string[] = [];
    let filterSource: string = '';
    let filterName: string = '';
    let fromDate = filters.fromDate ? this.gdoService.toMidnightTimestamp(Math.floor(filters.fromDate)) : this.fromDate;
    let toDate = filters.toDate ? this.gdoService.toEndDayTimestamp(Math.floor(filters.toDate)) : this.toDate;

    let filterGdoActivity: any[] = [];

    filters.selectedActivities?.forEach(element => {
      filterLockActivity.push(element['en-us']);
    });

    filters.selectedGdoActivities?.forEach(activity => {
      activity.event.forEach(event => {
        filterGdoActivity.push({eventId: event?.eventId, groupId: event?.groupId, eventBy: event?.eventBy});
      });
    });

    filters.selectedLocks?.forEach(element => {
      filterName = element;
    });

    filters.selectedSource?.forEach(element => {
      filterSource = element;
    });

    this.filterData = {
      toDate: toDate,
      fromDate: fromDate,
      lockActivity: filterLockActivity,
      lockName: filterName,
      lockUserType: filterSource,
      pageSize: this.pageSize,
      pageNumber: this.pageNo,
      orderBy: 'ID',
      sortOrder: 'desc',
      havDeviceName: filterName,
      havUserType: filterSource,

      havActivity: filterGdoActivity,
    };

  }

  convertUTCToGMT(time, timezone) {
    let dateTime = parseInt(time);

    if (timezone) {

      const plusIndex = 3;//timezone.indexOf('+');
      const timePart = timezone.substr(plusIndex + 1);
      const colonIndex = timePart.indexOf(':');

      let timeOffset = "";
      if (colonIndex >= 0) {

        timeOffset = timePart.substr(0, colonIndex);
        const minutesPart = timePart.substr(colonIndex + 1);

        timeOffset = `${parseInt(timeOffset) + (parseInt(minutesPart) / 60)}`;
      }
      else {

        timeOffset = timePart.substr(0);
      }

      const minutes = 60;
      const seconds = 60;

      const diff = parseFloat(timeOffset) * minutes * seconds;
      if (timezone[plusIndex] === '-')
        dateTime = dateTime - diff;
      else
        dateTime = dateTime + diff;
    }

    return dateTime;
  };
}
